import React, { useContext, useEffect } from "react";
import useManualUpload from "../../hooks/ManualUploadhook";
import useUserLogin from "../../hooks/UserLoginhook";
import { AuthContext } from "../AuthContextComponent";

interface OTPProps {
  data: any;
  label?: string;
  otps: string;
  otp: string[];
  type?: string;
  isClose: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>, index: number) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>, index: number) => void;
  onPaste: (e: React.ClipboardEvent<HTMLInputElement>, index: number) => void;
  setOpenOTP: any;
  userId: string;
  reset?: any;
  userData?: any;
  setOTP?: any;
}
const OTPComponent = ({
  label,
  otp,
  otps,
  data,
  type,
  isClose,
  onChange,
  onKeyDown,
  onPaste,
  setOpenOTP,
  userId,
  userData,
  reset,
  setOTP,
}: OTPProps) => {
  const userInfo = useContext(AuthContext);
  const { OTPSubmit } = useManualUpload();
  const { handleOTPLoginSubmit, textColorClass } = useUserLogin();

  useEffect(() => {
    if (otp.join("").length === otp.length) {
      if (type === "dataOTP") {
        OTPSubmit(otps, data, setOpenOTP, reset, setOTP);
      } else {
        handleOTPLoginSubmit(userId, otps, userData, setOTP);
      }
    }
  }, [otp, otps, data, setOpenOTP, OTPSubmit]);

  const backgroundColor = userInfo.userInfo?.theme === "DARK" ? "#2b3137" : "";
  return (
    <div className="w-full h-full">
      <div className="flex gap-2 justify-center items-center mx-auto px-4 h-full w-full">
        {otp.map((data, index) => {
          return (
            <input
              key={index}
              type="text"
              value={data}
              maxLength={1}
              onChange={(e) => onChange(e, index)}
              onKeyDown={(e) => onKeyDown(e, index)}
              onPaste={(e) => onPaste(e, index)}
              className={`border rounded-md md:h-16 md:w-16 h-12 w-12 flex items-center justify-center md:text-lg text-sm text-center font-bold border-custom-default-hover`}
              style={{ backgroundColor, borderColor: textColorClass }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default OTPComponent;
